import { render, staticRenderFns } from "./radiogroup-npts.vue?vue&type=template&id=48ce7433&scoped=true&lang=pug&"
import script from "./radiogroup-npts.vue?vue&type=script&lang=ts&"
export * from "./radiogroup-npts.vue?vue&type=script&lang=ts&"
import style0 from "./radiogroup-npts.vue?vue&type=style&index=0&id=48ce7433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce7433",
  null
  
)

export default component.exports